
import { brandsActions } from '../reducer';

import { BrandsState } from '../../types';

export const updateAddingFavouriteBrandsStatus = (status?: BrandsState['favouriteBrands']['addingStatus']) => brandsActions
  .setAddingFavouriteBrandsStatus(status);
